import './index.less'
import {Radio, Button, Popover, Tag, Spin, Image, Skeleton, Checkbox, Message} from "@arco-design/web-react";
import React, { useState, useEffect } from "react";
import CheckIcon from '@/assets/quick-img/check.png'
import {IconClose} from "@arco-design/web-react/icon";
import {getEffectApi, getFiltersApi} from "@/services/quickcut";
import QuickCutStore from '@/stores/quickCutStore'
const imageSize = { width: 84, height: 82 };
import { observer } from "mobx-react";
import YulanImg from '@/assets/cut-mix-detail/yulan.png'
const SpecialEffects = () => {
  const [position, setPosition] = React.useState('effects');
  const [baseUrl, setBaseUrl] = useState('')
  const [effects, setEffectList] = useState([]);
  const [filters, setFiltersList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [effectFlag, setEffectFlag] = useState(false)
  const [filterFlag, setFilterFlag] = useState(false)
  const [selectAll, setSelectAll] = useState(false);
  const MAX_SELECTION = 200;
  const { settings } = QuickCutStore.quickcutData
  useEffect(() => {
    getList();
  }, [position]);

  useEffect(() => {
    const currentItems = position === 'effects' ? effects : filters;
    const selectedItems = getData();
    setSelectAll(selectedItems.length > 0 && selectedItems.length === currentItems.length);
  }, [position, settings.effect, settings.filter, effects, filters]);

  const getData = () => {
    if (position === 'effects') {
      return settings.effect || [];
    } else if (position === 'filters') {
      return settings.filter || [];
    }
    return [];
  }
  const getList = () => {
    if (position === 'effects' && effectFlag && effects?.length > 0 ) {
      return;
    }
    if (position === 'filters' && filterFlag && filters?.length > 0 ) {
      return;
    }
    setLoading(true)
    const Api = position === 'effects' ? getEffectApi : getFiltersApi
    Api({
      limit: 999
    }).then(res => {
      setBaseUrl(res.data.base_url)
      if (position === 'effects') {
        setEffectList(res.data.items)
        setEffectFlag(true)
      }
      if (position === 'filters') {
        setFiltersList(res.data.items)
        setFilterFlag(true)
      }
      setLoading(false)
    }).catch(err => {
      setLoading(false)
      setEffectFlag(false)
      setFilterFlag(false)
    })
  }
  const getIds = () => {
    if (position === 'effects') {
      return settings.effect?.map(item => item.id) || [];
    } else {
      return settings.filter?.map(item => item.id) || [];
    }
  }
  return <div className={'specialEffects'}>
    <div className={'t-header'}>
      <Radio.Group
        type='button'
        name='position'
        value={position}
        onChange={setPosition}
        options={[{
          label: '特效',
          value: 'effects'
        }, {
          label: '滤镜',
          value: 'filters'
        }]}
      ></Radio.Group>
      <Checkbox
        style={{ marginRight: 10 }}
        checked={selectAll}
        onChange={(checked) => {
          const currentItems = position === 'effects' ? effects : filters;

          if (checked) {
            if (currentItems.length > MAX_SELECTION) {
              Message.warning(`最多只能选择${MAX_SELECTION}个${position === 'effects' ? '特效' : '滤镜'}`);
              return;
            }
            const currentData = position === 'effects' ? settings.effect || [] : settings.filter || [];
            const currentIds = new Set(currentData.map(item => item.id));
            const newItems = currentItems
              .filter(item => !currentIds.has(item.id))
              .map(item => ({
                id: item.id,
                name: item.name,
                ...JSON.parse(item.content)
              }));

            if (position === 'effects') {
              settings.effect = [...currentData, ...newItems];
            } else {
              settings.filter = [...currentData, ...newItems];
            }
          } else {
            // Clear all selections for the current position
            if (position === 'effects') {
              settings.effect = [];
            } else {
              settings.filter = [];
            }
          }
          setSelectAll(checked);
        }}
      >
        <span style={{ fontSize: 12 }}>全选</span>
      </Checkbox>
      {
        getData()?.length > 0 && <div className={'total'}>
              <span>已选择：{(getData() || []).length}</span>
              <Popover
                  trigger={'hover'}
                  position='br'
                  className="chose-detail-popover-wrapper"
                  style={{ height: 350, overflow: 'auto' }}
                  content={
                    <div className="chose-detail-content-wrapper">
                      <div className="chose-detail-content">
                        {(getData() || []).map((item) => {
                          return (
                            <Tag
                              key={item?.id}
                              color={"blue"}
                              style={{margin: "2px 2px"}}
                              className="chose-detail-popover-item"
                            >
                    <span>
                      {item?.name}
                      <IconClose
                        style={{cursor: "pointer", marginLeft: 4}}
                        onClick={() => {
                          if (position === 'effects') {
                            settings.effect = settings.effect.filter((i) => i.id !== item.id);
                          } else {
                            settings.filter = settings.filter.filter((i) => i.id !== item.id);
                          }
                        }}
                      />
                    </span>
                            </Tag>
                          );
                        })}
                      </div>
                    </div>
                  }
              >
                  <Button type={'text'}>查看详情</Button>
              </Popover>
              <span onClick={() => {
                if (position === 'effects') {
                  settings.effect = []
                } else {
                  settings.filter = []
                }
              }} className={'clear'}>清空</span>
          </div>
      }
    </div>
    <div className={'t-tableData'}>
      {!loading && (position === 'effects' ? effects : filters).map((item, index) => {
        const itemData = {
          id: item.id,
          name: item.name,
          ...JSON.parse(item.content)
        };

        const handleItemClick = () => {
          const isEffect = position === 'effects';
          const targetArray = isEffect ? settings.effect || [] : settings.filter || [];
          const itemIndex = targetArray.findIndex(i => i.id === item.id);

          if (itemIndex > -1) {
            // If item exists, remove it
            if (isEffect) {
              settings.effect = targetArray.filter(i => i.id !== item.id);
            } else {
              settings.filter = targetArray.filter(i => i.id !== item.id);
            }
          } else {
            // Check if we've reached the maximum selection
            if (targetArray.length >= MAX_SELECTION) {
              Message.warning(`最多只能选择${MAX_SELECTION}个${isEffect ? '特效' : '滤镜'}`);
              return;
            }

            // If not, add the new item
            const newItem = { ...itemData };
            if (isEffect) {
              settings.effect = [...targetArray, newItem];
            } else {
              settings.filter = [...targetArray, newItem];
            }
            QuickCutStore.previewFilter = [{ ...JSON.parse(item.content) }];
          }
        };

        const handlePreview = (e: React.MouseEvent) => {
          e.stopPropagation();
          QuickCutStore.previewFilter = [{ ...JSON.parse(item.content) }];
        };

        return (
          <div
            onClick={handleItemClick}
            className={getIds().includes(item.id) ? 'table-item active' : 'table-item'}
            key={item.id}
          >
            <Image
              preview={false}
              width={84}
              height={82}
              lazyload={{ threshold: 0.5 }}
              loader={<Skeleton image={{ style: imageSize }} text={false} animation />}
              className={'effect-img'}
              src={`${baseUrl}/${item.cover_url}`}
            />
            <div className={'effect-name'}>{item.name}</div>
            {getIds().includes(item.id) && (
              <div className={'check'}>
                <Checkbox checked={true} />
              </div>
            )}
            <img
              onClick={handlePreview}
              className={'look'}
              style={{ width: 16, height: 16 }}
              src={YulanImg}
              alt="预览"
            />
          </div>
        );
      })}

      {
        loading && <Spin className={'spin'} size={20}/>
      }
    </div>
  </div>
}
export default observer(SpecialEffects)
